import "./PayrollTimeSheetDataGridStyle.css";

import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	RHookFormNumberField,
	RequestParams,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatAmountCommaSeperator, formatAmountToFloat, formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount, getValueByFieldPath } from "../../../common/Common";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { MultiSelect } from "primereact/multiselect";
import isEqual from "lodash/isEqual";

export interface IPayrollTimeSheetDataGrid {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: string;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	PayrollTimeSheetData: (data: any) => void;
	allTotal: any;
	timeFormat: any;
	inputHours: any
}

export const PayrollTimeSheetDataGrid: React.FC<IPayrollTimeSheetDataGrid> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	PayrollTimeSheetData,
	allTotal,
	timeFormat,
	inputHours
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const [invalidatedCell, setInvalidatedCell] = useState<number>(0);
	const focusTargetRef = useRef<{ rowIndex: number; field: string } | null>(null);
	const [payrollItems, setPayrollItems] = useState<any>(
		rows && rows
	);
	const payrollItemsRef: any = useRef(payrollItems);

	useEffect(() => {
		payrollItemsRef.current = payrollItems;
	}, [payrollItems]);

	useEffect(() => {
		PayrollTimeSheetData(payrollItems);

	}, [payrollItems]);


	useEffect(() => {
		if (!isEqual(rows, payrollItems)) {
			setPayrollItems([...rows]);
		}
	}, [rows]);

	useEffect(() => {
		if (inputHours) {
			setInvalidatedCell(prev => prev + 1);
		}
	}, [inputHours]);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// Imitate delay of a backend call
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);
	// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	useEffect(() => {
		if (selectedItems && selectedItems.length > 0) {
			// Check if all selected items exist in rows
			const allExist = selectedItems.every((selectedItem: any) =>
				rows?.some((row: any) => row.employeeId === selectedItem.employeeId)
			);
			if (!allExist) {
				// ❌ One or more items removed → reset to initial state
				setSelectedItems([]);
				setSelectedItemsIds([]);
				if (selectedRowsValues) selectedRowsValues([]);
			}
		}
	}, [rows]);

	const getDateKey = (field: string): string | null => {
		if (!field) return null;
		if (field.startsWith("days.")) {
			const parts = field.split(".");
			// "days.2026-01-01.hours" splits to ["days", "2026-01-01", "hours"]
			return parts[1];
		}
		if (/^\d{4}-\d{2}-\d{2}$/.test(field)) {
			return field;
		}
		return null;
	};
	const updatePayrollItemHours = (rowIndex: number, field: string, value: number | null | string) => {
		setPayrollItems((prev: any[]) => {
			return prev.map((row: any, i: number) => {
				if (i !== rowIndex) return row;
				const dateKey = getDateKey(field);
				const updatedRow = { ...row };
				if (dateKey && updatedRow.days && dateKey in updatedRow.days) {
					updatedRow.days = {
						...updatedRow.days,
						[dateKey]: { ...updatedRow.days[dateKey], hours: value },
					};
				} else if (dateKey && updatedRow.days) {
					// dateKey exists but NOT found via `in` — force set it anyway
					updatedRow.days = {
						...updatedRow.days,
						[dateKey]: { hours: value },
					};
				} else {
					updatedRow[field] = value;
				}
				return updatedRow;
			});
		});
	};

	// const onCellValueChange = (column: any, rowIndex: number, value: any, rowData: any) => {
	// 	if (column.type === "number") {
	// 		if (value !== null && value !== undefined && value <= 0) {
	// 			onSnackbarMessageData && onSnackbarMessageData({
	// 				open: true,
	// 				message: "Invalid time value",
	// 				severity: "error"
	// 			});
	// 			updatePayrollItemHours(rowIndex, column.field, value);
	// 			setTimeout(() => {
	// 				updatePayrollItemHours(rowIndex, column.field, null);
	// 			}, 200);
	// 			setInvalidatedCell(prev => prev + 1);
	// 			return;
	// 		}
	// 		if (value !== null && value !== undefined && value > 23.59 && value !== 24) {
	// 			onSnackbarMessageData && onSnackbarMessageData({
	// 				open: true,
	// 				message: "Max 24 hours allowed",
	// 				severity: "error"
	// 			});
	// 			updatePayrollItemHours(rowIndex, column.field, value);
	// 			setTimeout(() => {
	// 				updatePayrollItemHours(rowIndex, column.field, null);
	// 			}, 200);
	// 			setInvalidatedCell(prev => prev + 1);
	// 			return;
	// 		} else {
	// 			const dateKey = getDateKey(column.field);
	// 			if (dateKey) {
	// 				// Sum all other rows' hours for this same date (excluding current row)
	// 				const otherRowsTotal = payrollItemsRef.current.reduce((sum: number, row: any, i: number) => {
	// 					if (i === rowIndex) return sum; // skip current row
	// 					const hours = row.days?.[dateKey]?.hours ?? 0;
	// 					return sum + Number(hours);
	// 				}, 0);

	// 				const newTotal = otherRowsTotal + (value ?? 0);

	// 				console.log('otherRowsTotal', otherRowsTotal)
	// 				console.log('newTotal', newTotal)

	// 				if (newTotal > 23.59 && newTotal !== 24) {
	// 					onSnackbarMessageData && onSnackbarMessageData({
	// 						open: true,
	// 						message: "Max 24 hours allowed",
	// 						severity: "error"
	// 					});
	// 					updatePayrollItemHours(rowIndex, column.field, value);
	// 					setTimeout(() => {
	// 						updatePayrollItemHours(rowIndex, column.field, null);
	// 					}, 200);
	// 					setInvalidatedCell(prev => prev + 1);
	// 					return;
	// 				}
	// 			}
	// 		}
	// 	}
	// 	updatePayrollItemHours(rowIndex, column.field, value);
	// };

	const onCellValueChange = (column: any, rowIndex: number, value: any, rowData: any) => {
		if (column.type === "number") {
			if (value !== null && value !== undefined && value < 0) {
				onSnackbarMessageData && onSnackbarMessageData({
					open: true, message: "Enter a valid value for Time i.e (hh.mm). Valid time range is 0.00 to 24.00.", severity: "error"
				});
				updatePayrollItemHours(rowIndex, column.field, null);
				setInvalidatedCell(prev => prev + 1);
				return;
			}

			const currentTimeFormat = timeFormat === 200 ? 23.59 : 23.99
			if (value !== null && value !== undefined && value > currentTimeFormat && value !== 24) {
				onSnackbarMessageData && onSnackbarMessageData({
					open: true, message: `Total hours for one day cannot be greater than 24.00.`, severity: "error"
				});
				updatePayrollItemHours(rowIndex, column.field, null);
				setInvalidatedCell(prev => prev + 1);
				return;
			}

			const dateKey = getDateKey(column.field);
			if (dateKey) {
				const otherRowsTotal = payrollItemsRef.current.reduce((sum: number, row: any, i: number) => {
					if (i === rowIndex) return sum;
					return sum + Number(row.days?.[dateKey]?.hours ?? 0);
				}, 0);

				// console.log('dateKeydateKeydateKey', dateKey)
				// console.log('newTotalnewTotal', allTotal)
				const savedTotalForOtherInputHours = allTotal[dateKey] ?? 0;
				// console.log('savedTotalForOtherInputHours', savedTotalForOtherInputHours)
				const newTotal = otherRowsTotal + savedTotalForOtherInputHours + (value ?? 0);

				if (newTotal > currentTimeFormat && newTotal !== 24) {
					onSnackbarMessageData && onSnackbarMessageData({
						open: true, message: `Total hours for one day cannot be greater than 24.00. ${24 - otherRowsTotal} hours left for this date.`, severity: "error"
					});
					updatePayrollItemHours(rowIndex, column.field, null);
					setInvalidatedCell(prev => prev + 1);
					return;
				}
			}
		}

		updatePayrollItemHours(rowIndex, column.field, value);
	};

	console.log('setPayrollItems', payrollItems)

	const columnsBody = (rowData: any, row: any, x: any) => {
		const value = getValueByFieldPath(rowData, x.field);
		if (x.type === 'text') {
			return (
				<InputText
					value={value}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value, rowData)}
				/>
			)
		} else if (x.type === 'dropdown') {
			return (
				<Dropdown
					options={rowData[`${x.field}Values`]}
					value={value}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.value, rowData)}
					placeholder="--"
					className={"input-dropdown-fields"}
				/>
			)
		} else if (x.type === 'number') {
			// const dateKey = getDateKey(x.field);
			// const numValue = dateKey
			// 	? rowData?.days?.[dateKey]?.hours
			// 	: rowData?.[x.field];

			// return (
			// 	<InputNumber
			// 		value={numValue}
			// 		onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
			// 		minFractionDigits={2}
			// 		maxFractionDigits={2}
			// 	/>
			// )

			const dateKey = getDateKey(x.field);
			const numValue = dateKey
				? rowData?.days?.[dateKey]?.hours ?? null
				: rowData?.[x.field] ?? null;

			return (
				<div
					data-row={row.rowIndex}
					data-field={x.field}
				>
					<InputNumber
						value={numValue}
						onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
						minFractionDigits={2}
						maxFractionDigits={2}
						inputStyle={{ textAlign: "right" }}
						onFocus={() => {
							focusTargetRef.current = { rowIndex: row.rowIndex, field: x.field };
						}}
					/>
				</div>
			);
		} else {
			return (
				<Typography sx={{ fontSize: ".875rem" }}
				>
					{rowData[x.field]}
				</Typography>
			)
		}
	};

	// const containerRef = useRef<HTMLDivElement>(null);
	// const [containerWidth, setContainerWidth] = useState(0);
	// const [totalColumnWidth, setTotalColumnWidth] = useState(0);

	// useEffect(() => {
	// 	if (!containerRef.current) return;
	// 	const observer = new ResizeObserver(([entry]) => {
	// 		setContainerWidth(entry.contentRect.width);
	// 	});
	// 	observer.observe(containerRef.current);
	// 	return () => observer.disconnect();
	// }, []);
	// useEffect(() => {
	// 	// compute total defined width of all columns
	// 	const totalColumnWidth = columns && columns.reduce(
	// 		(sum: any, col: any) => sum + (col.maxWidth || 0),
	// 		0
	// 	);
	// 	setTotalColumnWidth(totalColumnWidth)
	// }, [columns]);




	// row highlighting (yellow background) when clicking any cell in that row
	// const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);


	// const getRowClassName = (data: any, options: any) => {
	// 	return data.employeeId === activeRowIndex ? "highlighted-row" : "";
	// };
	useEffect(() => {
		if (invalidatedCell === 0) return;
		if (!focusTargetRef.current) return;

		const { rowIndex, field } = focusTargetRef.current;
		focusTargetRef.current = null;

		// Use requestAnimationFrame to wait for DOM to fully remount
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				const targetCell = document.querySelector(
					`[data-row="${rowIndex}"][data-field="${field}"] input`
				) as HTMLInputElement;

				if (targetCell) {
					targetCell.focus();
					targetCell.select();
				}
			});
		});
	}, [invalidatedCell]);

	return (
		<div
		// style={{
		// 	width: "100%",
		// 	overflow: "hidden", 
		// 	background: "#fff"
		// }}
		>
			<DataTable
				value={payrollItems && payrollItems}
				responsiveLayout="scroll"
				// editMode={managedBy !== 100 ? "cell" : undefined} //non-editable for managed by simplepay
				showGridlines
				// resizableColumns
				columnResizeMode="expand"
				scrollable
				key={invalidatedCell}
				// scrollHeight={tableScrollHeight ? "75vh" : ""}
				// reorderableColumns
				loading={isLoading ? isLoading : loading}
				footer={footer ? footer : undefined}
				emptyMessage="No Record found."
				className="PayrollTimeSheetDataGrid"
				// style={{
				// 	margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				// }}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				// selectionMode="multiple"
				selectionMode="checkbox"
				sortMode="single"
				/** 👇 Force fixed table layout so width styles are respected */
				// tableStyle={{ tableLayout: 'fixed', width: '100%' }}
				// tableStyle={{
				// 	tableLayout: 'fixed',
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : '100%',
				// }}
				// tableStyle={{
				// 	tableLayout: totalColumnWidth < containerWidth ? "fixed" : "auto",
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : "100%"
				// }}
				// onCellClick={(e) => alert("clicked")}
				// rowClassName={getRowClassName}
				onSort={onSort}
			>
				{columns && rows && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{rows && rows.length ? (
					<Column
						header="#"
						className="indexColumn"
						headerClassName="indexColumn"
						headerStyle={{ width: "24px" }}
						frozen
						hidden={!showIndexColumn}
						body={(data, options) => options.rowIndex + 1}
					></Column>
				) : undefined}
				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									// headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									// sortable={x.sortable}
									reorderable={false}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										width: x.maxWidth,
										maxWidth: x.maxWidth,
										// width: x.maxWidth,
									}}
									headerStyle={{
										whiteSpace: whiteSpace ? whiteSpace : "nowrap",
									}}
									headerClassName={
										x.weekendColumn
											? "weekend" : ""
									}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}
			</DataTable>
		</div>
	);
};
